import * as React from "react";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ServiceProposition } from "../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { TransferDestinationAccountModel } from "../../../../../../../Wrap/Models/Domains/Transfer/TransferDestinationAccountModel";
import { GiaTransfer } from "../../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Gia/GiaTransfer";
import { ClientDetails } from "../../../../../../../Wrap/Models/Models/Processes/Quote/ClientDetails";
import { Method } from "../../../../../../Shared/Common/Common";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { processTypeEnum } from "../../Resource/Contents";
import { AccountSearchPopup } from "./AccountSearchPopup";
import { CedingScheme } from "./CedingScheme";
import { CertificatedSharesAndEquity } from "./CertificatedSharesAndEquity";
import { ReRegInvestmentSeletion } from "./ReRegInvestmentSeletion";

interface ISingleTransferInPP extends IProcessComponentProps {
    isPost: boolean;
    index: number;
    data: GiaTransfer;
    clientDetails?: ClientDetails;
    jouneryType?: processTypeEnum;
    accountServiceProposition: ServiceProposition;
    claccountId?: string;
}

interface ISingleTransferInPPState {
    showAccountSearch: boolean;
    isLoadingInvestments: boolean;
    transferDestinationAccount?: TransferDestinationAccountModel;
}

export class SingleTransferInPP extends ProcessComponent<ISingleTransferInPP, ISingleTransferInPPState> {
    constructor(props: ISingleTransferInPP) {
        super(props);
        this.state = {
            showAccountSearch: false,
            isLoadingInvestments: false
        };
    }
    instrumentsCheck(): string[] {
        const { data } = this.props;
        const err: string[] = [];

        if (
            data?.ProviderDetails?.Name &&
            data?.ProviderDetails?.Name?.toLowerCase() !== "aberdeen platform limited wrap"
        ) {
            const instruments = data.Instruments;

            if (instruments.length === 0) {
                err.push("No instrument has been selected");
            } else if (instruments.length > 0) {
                for (let index = 0; index < instruments.length; index++) {
                    const strs = [],
                        instrument = instruments[index].Investment;
                    if (!(instruments[index].Units > 0)) {strs.push("Unit");}
                    strs.length &&
                        err.push(
                            `Please input an valid ${strs.join(" and ")} for the ${Method.Oridinal(
                                index + 1
                            )} instrument`
                        );
                }
            }
        }
        return err;
    }
    isValid() {
        let errors: string[] = [];
        let flag = super.isValid();
        errors = errors.concat(this.instrumentsCheck()); // check Re-Reg Investment Selection

        if (errors.length > 0) {
            this.props.showErrorMsgPopUp(errors, true);
            flag = false;
        }
        return flag;
    }
    render() {
        const { data, onChange } = this.props;
        const { showAccountSearch } = this.state;
        const subAccountType = SubAccountType.InvestmentAccount;
        return (
            <>
                <h4>Transfer type</h4>
                <p>Re-register assets</p>
                {/* <Typography type="vertical" config={[{ title: "Transfer type", data: "Re-register assets" }]} /> */}
                <p className="warning-message">
                    {"Please note that cash cannot be transferred into a Personal Portfolio."}
                </p>
                {(data?.ProviderDetails?.Name?.toLowerCase() == "aberdeen platform limited wrap" ||
                    data?.ProviderDetails?.Name?.toLowerCase() == "aberdeen platform limited fundzone") && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={
                            "Selecting a Treasured asset here will create a sell instruction. The instrument will continue to remain protected from auto-disinvestment, unless this a full sell order"
                        }
                    />
                )}
                <CedingScheme
                    data={data?.ProviderDetails}
                    onChange={(v) => this.onDataChange(onChange, v, data, "ProviderDetails")}
                    onRef={(ref) => this.appendChild(ref)}
                    type={SubAccountType.InvestmentAccount}
                    showErrorMsgPopUp={(msg, showNow) => this.props.showErrorMsgPopUp(msg, showNow)}
                    index={this.props.index}
                    onAccountNumberChange={(v) =>
                        this.onDataChange(onChange, { PolicyNumber: v }, data, "ExternalOwnershipDetails")
                    }
                    externalOwnerShip={data?.ExternalOwnershipDetails}
                    showElectronicRerRegistrationSupported={true}
                    hasCertificatedSharesAndEquities={data.ExternalOwnershipDetails?.Certificated}
                    onProviderSelected={(v) => {
                        if (v) {
                            this.props.onChange({ Instruments: [] });
                            this.onDataChange(onChange, { Certificated: false }, data, "ExternalOwnershipDetails");
                        }
                    }}
                    jouneryType={this.props.jouneryType}
                />

                {data?.ProviderDetails?.Name?.toLowerCase() == "aberdeen platform limited wrap" && (
                    <>
                        <div className="row">
                            <button
                                className="btn secondary label-offset mr-10"
                                onClick={() => this.setState({ showAccountSearch: true })}
                            >
                                Find Account
                            </button>
                            <button
                                className="btn secondary label-offset"
                                onClick={() => {
                                    onChange({ Instruments: [] });
                                    this.onDataChange(
                                        onChange,
                                        { PolicyNumber: null },
                                        data,
                                        "ExternalOwnershipDetails"
                                    );
                                }}
                            >
                                Clear
                            </button>
                        </div>
                    </>
                )}

                {showAccountSearch && (
                    <Lightbox
                        show={showAccountSearch}
                        title={"Account to transfer"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showAccountSearch: false })}
                        type={LightboxType.Modal}
                        unclosable={false}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox"
                    >
                        <AccountSearchPopup
                            onChange={(v, cgtExempt, changeOfBeneficial) => {
                                const fullName = v.Name.split(" ");
                                this.onDataChange(
                                    onChange,
                                    {
                                        PolicyNumber: v.ClAccountId,
                                        CgtExempt: cgtExempt,
                                        ChangeOfBeneficial: changeOfBeneficial,
                                    },
                                    data,
                                    "ExternalOwnershipDetails"
                                );
                                this.onDataChange(
                                    (changes) => this.onDataChange(onChange, changes, data, "ExternalOwnershipDetails"),
                                    { OwnerName: { Family: fullName[fullName.length - 1], Given: fullName[0] } },
                                    data.ExternalOwnershipDetails,
                                    "OwnedBy"
                                );
                                this.setState({ showAccountSearch: false, transferDestinationAccount: v });
                            }}
                            onInvestmentsChange={(v) => {
                                onChange({ Instruments: v });
                            }}
                            onLoadingInvestments={(v) => {
                                this.setState({ isLoadingInvestments: v });
                            }}
                            serviceProposition={this.props.accountServiceProposition}
                            claccountId={this.props.claccountId}
                            showcgtExempt={true}
                            subAccountType={subAccountType}
                        />
                    </Lightbox>
                )}

                {data.ExternalOwnershipDetails?.PolicyNumber != null &&
                    data?.ProviderDetails?.Name?.toLowerCase() == "aberdeen platform limited wrap" &&
                    data.Instruments &&
                    data.Instruments.length != 0 && (
                        <ReRegInvestmentSeletion
                            index={this.props.index}
                            isInternal={true}
                            data={data.Instruments}
                            onChange={(changes) => onChange({ Instruments: changes })}
                            onRef={(ref) => this.appendChild(ref)}
                            type={SubAccountType.InvestmentAccount}
                            accountServiceProposition={this.props.accountServiceProposition}
                            transferDestinationAccount={this.state.transferDestinationAccount}
                            isReview={this.props.isReview}
                            readonly={this.props.readonly}
                        />
                    )}
                {this.props.jouneryType != processTypeEnum.Quote && (
                    <RadiosEditor
                        cssWrapper="radio-group rg-inline  mt-25 mb-24"
                        options={[true, false]}
                        getText={(v) => (v ? "Yes" : "No")}
                        onChange={(v) => {
                            this.onDataChange(
                                onChange,
                                { Certificated: v, OwnedBy: null },
                                data,
                                "ExternalOwnershipDetails"
                            );
                            if (v) {
                                onChange({ ProviderDetails: null, Instruments: null });
                                this.onDataChange(onChange, { PolicyNumber: null }, data, "ExternalOwnershipDetails");
                            }
                        }}
                        selected={data?.ExternalOwnershipDetails?.Certificated}
                        label={"Are there any certificated shares/equities included in the transfer?"}
                        required="Please select"
                    />
                )}
                {((data?.ProviderDetails?.Name &&
                    data?.ProviderDetails?.Name?.toLowerCase() !== "aberdeen platform limited wrap") ||
                    data?.ExternalOwnershipDetails?.Certificated) && (
                    <ReRegInvestmentSeletion
                        index={this.props.index}
                        isInternal={false}
                        data={data.Instruments}
                        onChange={(changes) => onChange({ Instruments: changes })}
                        onRef={(ref) => this.appendChild(ref)}
                        type={SubAccountType.InvestmentAccount}
                        accountServiceProposition={this.props.accountServiceProposition}
                        isReview={this.props.isReview}
                        readonly={this.props.readonly}
                    />
                )}
                {this.props.jouneryType != processTypeEnum.Quote &&
                    data?.ExternalOwnershipDetails?.Certificated != null && (
                        <CertificatedSharesAndEquity
                            data={data?.ExternalOwnershipDetails?.OwnedBy}
                            onChange={(changes) =>
                                this.onDataChange(
                                    (changes) => this.onDataChange(onChange, changes, data, "ExternalOwnershipDetails"),
                                    changes,
                                    data.ExternalOwnershipDetails,
                                    "OwnedBy"
                                )
                            }
                            onRef={(ref) => this.appendChild(ref)}
                            isCertificated={data.ExternalOwnershipDetails?.Certificated}
                            clientDetails={this.props.clientDetails}
                        ></CertificatedSharesAndEquity>
                    )}
            </>
        );
    }
}
